import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { body } from '@constants/fonts';

export const InfoTextBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const PicBox = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  align-items: center;
  font-size: 20px;
  padding: 5px;
  img {
    margin-left: 6px;
  }
`;

export const SelfReportedHeader = styled.div`
  font-weight: normal;
  margin-top: -7px;
`;

export const MainText = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 17px;
  font-weight: 400;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 16px;
  }
`;

export const BottomText = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
`;

export const OuterContainer = styled.div<{ clickable: boolean; color: string }>`
  width: 100%;
  position: relative;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[24]};
  font-family: ${body};
  font-weight: lighter;
  text-align: left;

  border: none;
  border-right: 3px solid ${(props) => props.color};

  padding: 15px 20px 15px 12px;
  margin: 0 0 15px 0;
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};

  transition: box-shadow 0.1s;

  &:hover {
    ${(props) =>
      props.clickable ? `box-shadow: ${props.theme.shadows[24]};` : ''}
  }
`;

export const SubText = styled.div<{ color: string }>`
  color: ${(props) => props.color};
  font-size: 15px;
  text-transform: capitalize;

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`;

export const StatusContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.info.main};
  width: 6px;
  height: 6px;

  border-radius: 50%;
  position: absolute;
  top: calc(50% - 3px);
  left: 15px;
`;

export const HorizontalFlex = styled.div<
  PropsWithChildren<{
    border?: boolean;
    justifyContent?:
      'center' | 'flex-end' | 'flex-start' | 'space-between' | 'space-evenly';
    marginTop?: number;
    marginBottom?: number;
    marginRight?: number;
    marginLeft?: number;
    flexWrap?: boolean;
    width?: string;
    hideOverflow?: boolean;
    clickable?: boolean;
  }>
>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => props.justifyContent ?? 'space-between'};
  margin-top: ${(props) => props.marginTop ?? 10}px;
  margin-bottom: ${(props) => props.marginBottom ?? 10}px;
  margin-left: ${(props) => props.marginLeft ?? 0}px;
  margin-right: ${(props) => props.marginRight ?? 0}px;
  ${(props) => (props.flexWrap ? 'flex-wrap: inherit;' : '')}
  border-bottom: ${(props) =>
    props.border ? `1px solid ${props.theme.palette.divider}` : 'none'};
  ${(props) => (props.width ? `width: ${props.width};` : '')}
  ${(props) => (props.hideOverflow ? 'overflow: hidden;' : '')}

  ${(props) =>
    props.clickable
      ? `cursor: pointer;
  &:hover {
    background-color: ${props.theme.palette.action.hover}
  }`
      : ''}
`;

export const VerticalFlex = styled.div<
  PropsWithChildren<{
    alignItems?: 'center' | 'flex-end' | 'flex-start';
    justifyContent?: 'center' | 'flex-end' | 'flex-start';
    paddingLeft?: number;
    paddingRight?: number;
  }>
>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignItems ?? 'flex-start'};
  justify-content: ${(props) => props.justifyContent ?? 'center'};
  padding-right: ${(props) => props.paddingRight ?? 0}px;
  padding-left: ${(props) => props.paddingLeft ?? 0}px;
`;
